import { watch } from "vue";
import { useCore } from "@/core/core"

const { config, lng } = useCore()

/**
 * Will auto switch and load language file, depending on the setting in config.
 * @returns a promise for when the language is loaded and ready to use.
 */
export function useAutoLanguage() {
    watch(() => config.languageId, () => {
        if (lng.id !== config.languageId) {
            console.warn('switching language', config);
            lng.load(config);
        }
    });

    return lng.load(config);
}